import { HttpHandler, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceResponse } from 'src/app/@shared/interfaces/service-response.interface';
import { HttpClientService } from 'src/app/@shared/services/http-client/http-client.service';
import { environment } from 'src/environments/environment';
import { RouteCalendarAtStop } from '../interfaces/route-planning/gtfs/route-calendar-at-stop.interface';
import { TripStopTime, TripStopTimeSourceDestination } from '../interfaces/route-planning/gtfs/trip-stop-time.interface';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { NextDayOfService } from '../interfaces/route-planning/gtfs/next-day-of-service.interface';

@Injectable({
  providedIn: 'root',
})
export class CalendarRepository {
  constructor(
    private readonly httpClientService: HttpClientService,
    httpHandler: HttpHandler,
    languageService: LanguageService
  ) {
    this.httpClientService = new HttpClientService(httpHandler, languageService);
    this.httpClientService.apiUrl = environment.calendar_service_url;
  }

  GetRouteCalendarAtStops(model: {
    stopIds: number[];
    routeId: number;
    firstStopTime?: string;
    lastStopTime?: string;
  }): Observable<ServiceResponse<{ [stopId: number]: RouteCalendarAtStop }>> {
    return this.httpClientService.mot_get(
      'Calendar/GetRouteCalendarAtStops',
      HttpClientService.objectToQueryParams(model)
    );
  }

  GetTripCalendar(model: {
    routeId: number;
    stopId: number;
    stopSequence: number;
    dayPassingAtStop: number;
    timePassingAtStop: string;
  }): Observable<ServiceResponse<{ [stopId: number]: TripStopTime[] }>> {
    return this.httpClientService.mot_get(
      'Calendar/GetTripCalendar',
      HttpClientService.objectToQueryParams(model)
    );
  }

  GetRouteDailyCalendar(model: {
    startStopId: number;
    endStopId: number;
    routeId: number;
    day: string;
  }): Observable<
    ServiceResponse<{
      [stopId: number]: TripStopTime[];
    }>
  > {
    return this.httpClientService.mot_get(
      'Calendar/GetRouteDailyCalendar',
      HttpClientService.objectToQueryParams(model)
    );
  }

  GetRouteCalendarAtStopsByStopCodes(model: {
    stopCodes: string[];
    routeDesc: string;
    firstStopTime?: string;
    lastStopTime?: string;
  }): Observable<ServiceResponse<{ [stopId: number]: RouteCalendarAtStop }>> {
    return this.httpClientService.mot_get(
      'Calendar/GetRouteCalendarAtStopsByStopCodes',
      HttpClientService.objectToQueryParams(model)
    );
  }

  GetRouteNextDayOfService(routeId: number, day: string): Observable<ServiceResponse<NextDayOfService>> {
    return this.httpClientService.mot_get(
      'Calendar/GetRouteNextDayOfService',
      new HttpParams().set('routeId', routeId).set('dayToCheckFrom', day)
    );
  }

  GetTripCalendarForSourceDestination(model: {
    routeDesc: string;
    agencyId: number;
    stopCode: number;
    dateTime: string;
  }): Observable<ServiceResponse<Record<number, TripStopTimeSourceDestination[]>>> {
    return this.httpClientService.mot_get(
      'Calendar/GetTripCalendarByRouteDesc',
      HttpClientService.objectToQueryParams(model)
    );
  }
}
